import moneyFormat from "~/helpers/moneyFormat";

const coerceCellNumber = (rawValue: unknown): number | null => {
	if (rawValue === "" || rawValue == null) {
		return null;
	}
	const parsed = typeof rawValue === "number" ? rawValue : Number(rawValue);
	return Number.isNaN(parsed) ? null : parsed;
};

// AG Grid 35 formats the pending editor value during commit, so a raw editor string reaches this formatter.
export const formatCurrencyCell = (value: unknown): string => {
	const amount = coerceCellNumber(value);
	return amount ? moneyFormat(amount, "USD") : "";
};

export default coerceCellNumber;
